<template>
  <!-- 注意：逻辑部分尽量不好写到这个组件内，因为这个组件是根据外面table循环创建的，在这里写逻辑会非常影响性能 -->
  <div @click.stop style="display: inline-block">
    <el-popover
        v-if="!isEmpty(prop())"
        placement="bottom"
        width="200"
        trigger="click"
        :visible="popoverShow"
        ref="popoverRef"
    >
      <div style="display:flex;">
        <el-link :class="{label,labelColor:conditionTypeThis === 'txt'}" @click="updateConditionType('txt')">文本</el-link>
        <el-link :class="{label,abelColor:conditionTypeThis === 'scope'}" @click="updateConditionType('scope')">范围</el-link>
        <el-link :class="{label,labelColor:conditionTypeThis === 'date'}" @click="updateConditionType('date')">日期</el-link>
        <el-link :class="{label,labelColor:conditionTypeThis === 'datetime'}" @click="updateConditionType('datetime')">时间</el-link>
        <el-link v-if="options().length !== 0" :class="{label,labelColor:conditionTypeThis === 'list'}" @click="updateConditionType('list')">列表</el-link>
      </div>
      <!-- txt 文本 -->
      <div v-if="conditionTypeThis === 'txt'">
        <el-input
            v-model="conditions1"
            clearable
            placeholder="请输入查询内容"
            @focus="focus = true"
            @blur="focus = false"
            @change="screenChange(conditionTypeThis,conditions1)"
            @keyup.native.enter="confirm"
        ></el-input>
      </div>
      <!-- scope 范围-->
      <div v-if="conditionTypeThis === 'scope'">
        <el-input
            style="width: 75px"
            clearable
            v-model="conditions1"
            @focus="focus = true"
            @blur="focus = false"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            placeholder="请输入条件1"
            @keyup.enter="confirm"
        ></el-input>
        -
        <el-input
            style="width: 75px"
            clearable
            @focus="focus = true"
            @blur="focus = false"
            v-model="conditions2"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            placeholder="请输入条件2"
            @keyup.native.enter="confirm"
        ></el-input>
      </div>
      <!-- date 日期-->
      <div v-if="conditionTypeThis === 'date'">
        <el-date-picker
            v-model="conditions1"
            @focus="focus = true"
            @blur="focus = false"
            type="date"
            style="width: auto;"
            clearable
            placeholder="开始日期"
            value-format="YYYY-MM-DD"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            @keyup.native.enter="confirm"
        ></el-date-picker>
        <el-date-picker
            style="margin-top: 10px;width: auto;"
            v-model="conditions2"
            @focus="focus = true"
            @blur="focus = false"
            type="date"
            clearable
            placeholder="结束日期"
            value-format="YYYY-MM-DD"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            @keyup.native.enter="confirm"
        ></el-date-picker>
      </div>
      <!-- datetime 日期时间-->
      <div v-if="conditionTypeThis === 'datetime'">
        <el-date-picker
            v-model="conditions1"
            @focus="focus = true"
            @blur="focus = false"
            type="datetime"
            style="width: auto;"
            clearable
            placeholder="开始时间"
            value-format="YYYY-MM-DD HH:mm:ss"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            @click.stop
            @keyup.native.enter="confirm"
        ></el-date-picker>
        <el-date-picker
            style="margin-top: 10px;width: auto;"
            v-model="conditions2"
            @focus="focus = true"
            @blur="focus = false"
            type="datetime"
            clearable
            placeholder="结束时间"
            value-format="YYYY-MM-DD HH:mm:ss"
            @change="screenChange(conditionTypeThis,[conditions1,conditions2])"
            @keyup.native.enter="confirm"
        ></el-date-picker>
      </div>
      <!-- list 列表 -->
      <div v-if="conditionTypeThis === 'list'">
        <el-select
            @focus="focus = true"
            @blur="focus = false"
            @change="screenChange(conditionTypeThis,conditionsList)"
            v-model="conditionsList"
            filterable
            clearable
            multiple
            aria-hidden="false"
            placeholder="Select"
        >
          <el-option
              v-for="item in options()"
              :key="item"
              :label="item"
              :value="item"
          />
        </el-select>
      </div>
      <!-- label 标题显示-->
      <template #reference>
        <span
            slot="reference"
            oncontextmenu="return false"
            class="label"
            @click="titleClick"
            :class="{ labelColor: !isEmpty(conditions1) || !isEmpty(conditions2) || conditionsList.length > 0 }"
        >
          {{ label() }}
        </span>
      </template>
    </el-popover>
    <span
        v-if="isEmpty(prop())"
        slot="reference"
        oncontextmenu="return false"
        class="label"
        :class="{ labelColor: !isEmpty(conditions1) || !isEmpty(conditions2) || conditionsList.length > 0 }"
    >
      {{ label() }} &nbsp;<i class="el-icon-arrow-down"></i>
    </span>
  </div>
</template>

<script>

export default {
  props: {
    conditionType: {
      type: String,
      default: "txt",
    },
    conditionDefault: {
      type: [String, Array],
    },
    headerScope: {
      type: Object,
    },
    searchList: {
      type: Function,
      default: () => function () { return []; },
    },
    couldAdd: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      conditionTypeThis: this.conditionType,
      popoverShow: false,
      conditions1: null,
      conditions2: null,
      conditionsList: [],
      focus: false,
    };
  },
  methods: {
    label() {
      try {
        return this.headerScope.column.label;
      } catch (e) {
        return "";
      }
    },
    prop() {
      try {
        return this.headerScope.column.property;
      } catch (e) {
        return "";
      }
    },
    options() {
      try {
        let _options = this.searchList().map((item) => {
          return this.isEmpty(item[this.prop()]) ? "(空)" : item[this.prop()];
        });
        return _options.filter((item, index) => {
          return _options.indexOf(item) === index;
        });
      } catch (e) {
        return [];
      }
    },
    isEmpty(val) {
      return val === "" || val === null || val === undefined;
    },
    updateConditionType(type) {
      this.focus = true;
      this.conditionTypeThis = type;
      this.conditions1 = null;
      this.conditions2 = null;
      this.conditionsList = [];
      setTimeout(() => {
        this.focus = false;
      }, 0);
    },
    confirm() {
      if (!this.conditions1 && !this.conditions2) {
        return this.$message.warning("请选择筛选条件");
      }
    },
    titleClick() {
      this.popoverShow = !this.popoverShow;
    },
    dateScreen(datasource) {
      if (this.isEmpty(this.conditions1) && this.isEmpty(this.conditions2) && this.conditionsList.length === 0) {
        return datasource;
      }
      switch (this.conditionTypeThis) {
        case "date":
        case "datetime":
        case "scope":
          if (this.isEmpty(this.conditions1) && this.isEmpty(this.conditions2)) {
            return datasource;
          } else {
            return datasource.filter(item => {
              return (this.couldAdd && item.id !== undefined && item.id < 0) ||
                ((this.isEmpty(this.conditions1) || item[this.prop()] >= this.conditions1) &&
                (this.isEmpty(this.conditions2) || item[this.prop()] <= this.conditions2));
            });
          }
        case "txt":
          try {
            return datasource.filter(item => {
              return (this.couldAdd && item.id !== undefined && item.id < 0) ||
                (!this.isEmpty(item[this.prop()]) && item[this.prop()].toString().includes(this.conditions1));
            });
          } catch (e) {
            console.error(e);
            return datasource;
          }
        case "list":
          try {
            return datasource.filter(item => {
              if (this.couldAdd && item.id !== undefined && item.id < 0) {
                return true;
              }
              if (this.conditionsList.includes("(空)")) {
                return this.isEmpty(item[this.prop()]) || this.conditionsList.includes(item[this.prop()]);
              } else {
                return this.conditionsList.includes(item[this.prop()]);
              }
            });
          } catch (e) {
            console.error(e);
            return datasource;
          }
        default:
          return datasource;
      }
    },
    handleClickOutside(event) {
      if (!this.focus && this.$refs.popoverRef && !this.$refs.popoverRef.$el.contains(event.target)) {
        this.popoverShow = false;
      }
    },
    screenChange(conditionType, screen) {
      this.$emit("screenChange", conditionType, screen, this.prop);
    },
  },
  mounted() {
    switch (this.conditionType) {
      case "txt":
        this.conditions1 = this.conditionDefault ? this.conditionDefault : null;
        break;
      case "list":
        this.conditionsList = this.conditionDefault ? this.conditionDefault : [];
        break;
      case "date":
      case "datetime":
      case "scope":
        this.conditions1 = this.conditionDefault ? this.conditionDefault[0] : null;
        this.conditions2 = this.conditionDefault ? this.conditionDefault[1] : null;
        break;
    }
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* 样式部分保持不变 */
.confirm {
  margin-top: 10px;
}
.label {
  -moz-user-select: none;
  -webkit-user-select: none !important;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.labelColor {
  color: #409eff;
}
.label:hover {
  color: #409eff;
  cursor: pointer;
}
.el-link {
  margin-right: 5px;
  font-size: 12px;
}
.el-link .el-icon--right.el-icon {
  vertical-align: text-bottom;
}
</style>